module.exports = __webpack_public_path__ + "static/media/snare.c8be1eff.mp3";